import { render, staticRenderFns } from "./CreateBitrixChannel.vue?vue&type=template&id=0116593e&scoped=true"
import script from "./CreateBitrixChannel.vue?vue&type=script&lang=js"
export * from "./CreateBitrixChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateBitrixChannel.vue?vue&type=style&index=0&id=0116593e&prod&lang=scss&scoped=true"
import style1 from "./CreateBitrixChannel.vue?vue&type=style&index=1&id=0116593e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0116593e",
  null
  
)

export default component.exports